import React from 'react'; // eslint-disable-line
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _actions from '../../actions';
import LargeLoading from '../../components/svg/LargeLoading';

class LoggedOut extends React.Component {
    componentDidMount() {
        let sessionId = sessionStorage.getItem("SessionId");
        localStorage.clear();
        this.props.actions.logout();
        window.location = `${window.GENESIS_CMS_API_URL}/logout?sessionId=${sessionId}`;
    }

    render() {
        return (
            <div className="logged-out">
                <LargeLoading />
            </div>

        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOut);
